import { graphql, useStaticQuery } from 'gatsby';
import { uniqBy } from 'lodash';
import React, { useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import FlipMove from 'react-flip-move';
import { ElementTag } from 'src/components/ElementTags/ElementTags';
import NodeProjectCard from 'src/components/NodeProjectCard/NodeProjectCard';
import { useTheme } from 'src/hooks';

const getUniqueCategories = (projects) => {
  const categories = projects.reduce((acc, curr) => [...acc, ...curr.category], []);

  return uniqBy(categories, 'id');
};

export const ProjectsListing = ({ showFilters, showAllProjects, projects }) => {
  const data = useStaticQuery(graphql`
    {
      allSanityProject(sort: { _updatedAt: DESC }) {
        nodes {
          ...getProjectsAsCards
        }
      }
    }
  `);

  const hasSlug = (item) => item.slug !== null;

  const allProjects = data.allSanityProject.nodes;

  const projectsToShow = showAllProjects ? allProjects.filter(hasSlug) : projects.filter(hasSlug);

  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  const { pages } = useTheme();

  const categories = [
    {
      name: pages.project.projectFilter.all,
      color: 'blue-light',
      id: null,
    },
    ...getUniqueCategories(projectsToShow),
  ];

  const onCategoryClick = (e, id) => {
    e.preventDefault();
    setSelectedCategoryId(id);
  };

  const filteredCategories = selectedCategoryId
    ? projectsToShow.filter((project) => project.category.some((category) => category.id === selectedCategoryId))
    : projectsToShow;

  if (!projectsToShow) return null;

  return (
    <Container className="pt-xl-6">
      {showFilters && (
        <Row noGutters className="mx-n2">
          {categories.map(({ id, color, name }) => (
            <Col key={id} xs="auto" className="px-2">
              <ElementTag
                onClick={(e) => onCategoryClick(e, id)}
                isActive={selectedCategoryId === id}
                color={color}
                id={id}
                name={name}
                isButton
              />
            </Col>
          ))}
        </Row>
      )}
      <Row style={{ position: 'relative' }} className="mx-xl-n3">
        <FlipMove typeName={null}>
          {filteredCategories.map((project) => (
            <Col key={project.id} xs={12} lg={6} className="px-xl-3 py-5">
              <NodeProjectCard card={project} />
            </Col>
          ))}
        </FlipMove>
      </Row>
    </Container>
  );
};
